"use client";

import React from "react";
import Image from "next/image";
import BgTexture from "@/assets/banner/Mask group (4).png";
import QuoteMark from "@/assets/banner/“.svg";
import ChancellorPhoto from "@/assets/banner/Mask group.svg";

const Gradientsection = () => {
    return (
        <section className="w-full bg-[#081E2D] mt-20 relative mb-10 overflow-hidden">
            <div className="absolute inset-0 pointer-events-none">
                <Image
                    src={BgTexture}
                    alt="Background"
                    fill
                    className="object-cover "
                />
            </div>
            <div className="relative max-w-[1109px] mx-auto py-10 md:py-14 lg:py-24">
                <div className="flex flex-col md:flex-row items-center md:items-center gap-8 md:gap-12">
                    <div className="relative flex items-center justify-center md:justify-start">
                        <div className="absolute -top-5 -left-10">
                            <Image
                                src={QuoteMark}
                                alt="Quote mark"
                                className="md:w-[82px] md:h-[86px] object-contain"
                            />
                        </div>

                        <div className="relative w-32 h-32 sm:w-40 sm:h-40 md:w-48 md:h-48 rounded-full overflow-hidden  shadow-lg">
                            <Image
                                src={ChancellorPhoto}
                                alt="Hon'ble Shri. Pravesh Dudani"
                                fill
                                className="object-cover"
                            />
                        </div>
                    </div>

                    {/* Right: text */}
                    <div className="flex-1 text-left">
                        <p
                            className="text-base sm:text-lg md:text-2xl lg:text-[32px] text-white leading-relaxed md:leading-snug "
                            style={{ fontFamily: "saans-regular" }}
                        >
                            “At the heart of our University lies a profound commitment to not
                            only educate but to also elevate the youth of our nation.”
                        </p>

                        <div className="mt-6 md:mt-8 md:flex md:justify-end">
                            <div className="text-left  md:text-right">
                                <div className="md:flex items-center gap-5">
                                    <div className="h-px md:w-[228px] md:w-32 bg-white/30  md:ml-auto" />
                                    <p
                                        className="text-xs sm:text-sm lg:text-base text-[#F9B51E] md:mt-0 mt-5 font-semibold"
                                        style={{ fontFamily: "saans-bold" }}
                                    >
                                        Shri Pravesh Dudani
                                    </p>
                                </div>
                                <p
                                    className="mt-1 text-[10px] sm:text-xs lg:text-sm text-white/70"
                                    style={{ fontFamily: "saans-regular" }}
                                >
                                    Founder &amp; Chancellor, Medhavi Skills University
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Gradientsection
